import { Component, OnInit } from '@angular/core'

@Component({
    selector: './achelous-videos',
    templateUrl: './achelous-videos.component.html',
    styleUrls: ['../../../../../help.component.css']
})

export class AchelousVideosComponent implements OnInit {

    ngOnInit() {

    }
}